import { Alert, Button, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Link as RouterLink, useParams } from 'react-router-dom';
import type { RegistryOffer } from '../../api/registryDealTypes';
import { errorMessage } from '../../api/registryApi';
import { useRegistrySession } from '../../session/RegistrySession';
import { KeyValueGrid, PageHeader, SectionCard, StatusChip } from '../../ui/primitives';

export default function LiveOfferDetailPage() {
  const { offerId = '' } = useParams();
  const session = useRegistrySession()!;
  const [offer, setOffer] = useState<RegistryOffer | null>(null);
  const [error, setError] = useState('');
  useEffect(() => {
    session.api
      .getOffer(offerId)
      .then(setOffer)
      .catch((failure) => setError(errorMessage(failure)));
  }, [session, offerId]);
  if (!offer)
    return error ? (
      <Alert severity="error">{error}</Alert>
    ) : (
      <Typography>Loading offer…</Typography>
    );
  return (
    <>
      <PageHeader
        eyebrow="Live from Fides"
        title={offer.title}
        subtitle={`${offer.fund.name} · ${offer.unitClass.name}`}
        actions={<StatusChip status={offer.status} />}
      />
      {offer.rejectionComment && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          Last rejection: {offer.rejectionComment}
        </Alert>
      )}
      {offer.status === 'PENDING_APPROVAL' && (
        <Alert severity="info" sx={{ mb: 2 }}>
          Waiting for a second person&apos;s approval.
        </Alert>
      )}
      <SectionCard title="Offer terms">
        <KeyValueGrid
          items={[
            {
              label: 'Fund opportunity',
              value: `${offer.fundOpportunity.name} · ${offer.fundOpportunity.status}`,
            },
            {
              label: 'Closes',
              value: `${offer.closeDate} ${offer.closeTime} (${offer.closeTimeZone})`,
            },
            { label: 'Minimum', value: `$${offer.minimumAmount}` },
            { label: 'Maximum', value: offer.maximumAmount ? `$${offer.maximumAmount}` : 'None' },
            { label: 'Payment methods', value: offer.paymentMethods.join(', ') },
            { label: 'Applications', value: '0 · available in milestone 5' },
          ]}
        />
      </SectionCard>
      <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
        <Button
          component={RouterLink}
          to={`/manager/setup/${offer.dealSetupExternalId}?step=review`}
        >
          Open setup
        </Button>
        <Button component={RouterLink} to="/manager/approvals">
          Approvals inbox
        </Button>
      </Stack>
    </>
  );
}
